import CryptoJS from 'crypto-js';
import { jwtDecode } from "jwt-decode";

export function hashPassword(password) {
    const hash = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
    return hash;
}

export function parseJwt(token) {
    return jwtDecode(token);
};

